import kavyaImage from "./KavyaImage.jpeg";
import siddarajuImage from "./Siddaraju M.jpg";
import srivaasanImage from "./Jayapura.jpg";
import niranjanImage from "./Niranjan.JPG";
import sharanappaIImage from "./Sharanappa Y.JPG";
import sharanappaKImage from "./Sharan.PNG";
import SachinImage from "./Sachin Walke.jpg";
import savithaImage from "./Savitha S.jpg";
import shobhaImage from "./Shobha D.JPG";
// import shobhaImage from "./Shobha D.JPG";
import Doctor from "./Doctor.jpg";
import { motion } from "framer-motion";

const firstRowMembers = [
  { name: "KAVYA R", role: "Proprietor", image: kavyaImage },
  {
    name: "SIDDARAJU. M",
    role: "Chief Executive Officer",
    phone: "+91 98459 88061",
    image: siddarajuImage,
  },
  {
    name: "Dr. SRIVAASAN.J",
    role: "Chief Technical Head",
    // phone: "+91 96866 70032",
    image: Doctor,
  },

  {
    name: "NIRANJAN",
    role: "Operations Manager - Karnataka",
    // phone: "+91 95350 55393",
    image: niranjanImage,
  },
  {
    name: "SHARANAPPA",
    role: "Field Manager",
    // phone: "+91 99001 93030",
    image: sharanappaIImage,
  },
];

const secondRowMembers = [
  { name: "SACHIN", role: "Field Manager", image: SachinImage },
  {
    name: "SAVITHA",
    role: "Operations Executive - Bangalore",
    image: savithaImage,
  },
  { name: "SHOBHA", role: "Admin & Accounts Executive", image: shobhaImage },
  {
    name: "Mr. NAGARAJU.S",
    role: "Field Manager - Mysuru",
    // phone: "+91 90350 27813",
    image: srivaasanImage,
  },
  {
    name: "SHARAN",
    role: "Field Manager - Hubballi",
    // phone: "+91 90350 27821",
    image: sharanappaKImage,
  },
];

export default function Team() {
  return (
    <div
      className="bg-gradient-to-r from-red-300 to-red-900 pt-10 mt-14 h-auto pb-16 scroll-mt-[100px]"
      id="teams"
    >
      {/* Section Title */}
      <h1 className="mt-2 pt-12 text-center text-white font-bold text-3xl">
        Our Team
      </h1>

      {/* First Row - 3 Images (Aligned at Same Height) */}
      <div className="flex justify-center mt-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-10 place-items-center">
          {firstRowMembers.map((member, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center h-full"
            >
              <motion.img
                whileHover={{
                  scale: 1.08,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
                }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                src={member.image}
                alt={member.name}
                className="h-[20vh] w-[20vh] bg-gray-950 border-2 rounded-full shadow-2xl mt-5 cursor-pointer"
              />
              <div className="mt-3">
                <h1 className="text-xl font-bold">{member.name}</h1>
                <p className="text-medium font-medium">{member.role}</p>
                {member.phone && (
                  <p className="text-medium font-medium">{member.phone}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Second Row - 5 Images */}
      <div className="flex justify-center mt-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-10 place-items-center">
          {secondRowMembers.map((member, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center h-full"
            >
              <motion.img
                whileHover={{
                  scale: 1.08,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
                }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                src={member.image}
                alt={member.name}
                className="h-[20vh] w-[20vh] bg-gray-950 border-2 rounded-full shadow-2xl cursor-pointer"
              />
              <div className="mt-3">
                <h1 className="text-xl font-bold">{member.name}</h1>
                <p className="text-medium font-medium">{member.role}</p>
                {member.phone && (
                  <p className="text-medium font-medium">{member.phone}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
